import "./About.css";

function About() {
  return (
    <section className="about-page" id="about">
      <div className="about-layout">
        <div className="about-images">
          <img
            className="about-main-image"
            src="/Aboutimg/prj1.jpeg"
            alt="Sarrathi Constructions site work"
          />

          <img
            className="about-small-image"
            src="/Aboutimg/prj4.jpeg"
            alt="Sarrathi Constructions project"
          />
        </div>

        <div className="about-content">
          <p className="section-eyebrow">About Us</p>

          <h1>
            Built on Trust.
            <span> Delivering Excellence.</span>
          </h1>

          <p className="about-description">
            We founded our company out of pure love and passion for the
            engineering and construction industry. From the very beginning, our
            mission has been to create spaces that inspire, uplift, and bring
            lasting value to the people who live in them.
          </p>

          <p className="about-description">
            Over the past 40+ years, we have built a reputation rooted in
            quality, trust, and dedication. Our greatest reward is not just the
            structures we build, but the joy we see on our clients’ faces when
            their dream homes come to life.
          </p>

          <div className="about-highlights">
            <div className="about-highlight">
              <span className="highlight-icon">✓</span>
              <div>
                <strong>40+ Years of Experience</strong>
                <p>Trusted construction expertise</p>
              </div>
            </div>

            <div className="about-highlight">
              <span className="highlight-icon">✓</span>
              <div>
                <strong>40+ Projects</strong>
                <p>Residential, commercial, and industrial projects</p>
              </div>
            </div>

            <div className="about-highlight">
              <span className="highlight-icon">✓</span>
              <div>
                <strong>100+ Happy Customers</strong>
                <p>Built through quality, trust, and dedication</p>
              </div>
            </div>
          </div>

          <a
            href="/"
            className="about-action"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("contact")?.scrollIntoView({
                behavior: "smooth",
              });
            }}
          >
            Let's build together <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;
